import {ViewController} from "data/types/structure";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import {inject, injectable} from "inversify";
import {makeAutoObservable, observable} from "mobx";
import {Bindings} from "data/constants/bindings";
import {ALLOWED_LANGUAGES} from "data/constants";
import {changeRouteLanguage, getLanguageFromPath} from "data/utils/language";
import RallySSO from "data/utils/SSO/rallySSO";
import {createFanHubEvent, EventGUID} from "data/utils/analytics";

export interface IHeaderController extends ViewController {
	readonly i18n: ILocalizationStore;
	get currentLanguage(): string;
	get secondLanguage(): string;
	get isNative(): boolean;

	languageToggle: () => void;
}

@injectable()
export class HeaderController implements IHeaderController {
	@observable private _isNative: boolean = RallySSO.IS_NATIVE;
	constructor(@inject(Bindings.LocalizationStore) public readonly i18n: ILocalizationStore) {
		makeAutoObservable(this);
	}

	get currentLanguage() {
		return !ALLOWED_LANGUAGES.includes(getLanguageFromPath()) || getLanguageFromPath() === "en"
			? "en"
			: "es";
	}

	get secondLanguage() {
		return !ALLOWED_LANGUAGES.includes(getLanguageFromPath()) || getLanguageFromPath() === "en"
			? "es"
			: "en";
	}

	get isNative() {
		return this._isNative;
	}

	public languageToggle = () => {
		const newLanguage = this.currentLanguage === "es" ? "en" : "es";
		createFanHubEvent(EventGUID.LanguageChangeClick);
		changeRouteLanguage(this.currentLanguage, newLanguage);
	};
}
